const state = {
  locale: localStorage.getItem('locale') || 'ru',
  loading: false,
  openAuthModal: false,
  openSuccessRegistration: false,
  openWaitTransaction: false
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js